import React from 'react';
import { COLOR_MAP } from '../../constants/colorConstants';
import { getStrokeWidth } from '../../utils/cableLogic';

const normalizeColorForVisualization = (color) => {
  if (!color) return color;
  return color;
};

const isEarthWire = (color) => {
  const normalized = normalizeColorForVisualization(color);
  return normalized === 'GI/VE' || normalized === 'YE/GN';
};

const CableSVGPath = ({
  cable,
  d,
  isHovered = false,
  opacity = 1,
  useAWG = false,
  className = '',
  ...otherProps
}) => {
  const isGialloVerde = isEarthWire(cable.colore);
  const strokeWidth = getStrokeWidth(cable.sezione, isHovered, useAWG);

  if (isGialloVerde) {
    // Pattern giallo/verde per cavi di terra
    return (
      <>
        <path
          d={d}
          stroke={COLOR_MAP['GIALLO']}
          strokeWidth={strokeWidth}
          opacity={opacity}
          fill="none"
          strokeDasharray="8 8"
          strokeDashoffset={0}
          className={className}
          strokeLinecap="round"
          strokeLinejoin="round"
          {...otherProps}
        />
        <path
          d={d}
          stroke={COLOR_MAP['VERDE']}
          strokeWidth={strokeWidth}
          opacity={opacity}
          fill="none"
          strokeDasharray="8 8"
          strokeDashoffset={8}
          className={className}
          strokeLinecap="round"
          strokeLinejoin="round"
          {...otherProps}
        />
      </>
    );
  } else {
    // Path singolo per altri colori
    const solidColor = COLOR_MAP[normalizeColorForVisualization(cable.colore)] || '#808080';
    const isWhite = solidColor === '#FFFFFF';

    if (isWhite) {
      // Per cavi bianchi, aggiungi un bordo scuro per la visibilità
      return (
        <>
          {/* Bordo scuro per visibilità */}
          <path
            d={d}
            stroke="#666666"
            strokeWidth={strokeWidth + 1}
            fill="none"
            className={`cable-path-border ${isHovered ? 'animated' : ''} ${className}`}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...otherProps}
          />
          {/* Path bianco principale */}
          <path
            d={d}
            stroke={solidColor}
            strokeWidth={strokeWidth}
            fill="none"
            className={`cable-path ${isHovered ? 'animated' : ''} ${className}`}
            opacity={opacity}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...otherProps}
          />
        </>
      );
    } else {
      // Path normale per altri colori
      return (
        <path
          d={d}
          stroke={solidColor}
          strokeWidth={strokeWidth}
          fill="none"
          className={`cable-path ${isHovered ? 'animated' : ''} ${className}`}
          opacity={opacity}
          strokeLinecap="round"
          strokeLinejoin="round"
          {...otherProps}
        />
      );
    }
  }
};

export default CableSVGPath;


